
<script setup>
import CustomComboBox from "@/components/Custom_DDL_Checkbox.vue";
</script>
<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Sawit Buah table</h6>
         
          <div class="row">
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Block ID</label>
                <CustomComboBox :list="blockList" v-model="search.blockid"/>
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Perkerja</label>
                <select id="select_perkerja" class="form-control" v-model="search.perkerja">
                  <option value="%">All</option>
                  <option value="0">Dani</option>
                  <option value="1">Perkerja Sendiri</option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Driver</label>
                <select id="select_driver" class="form-control" v-model="search.driver">
                  <option value="%">All</option>
                  <option value="Tangga">Tangga</option>
                  <option value="Wan">Wan</option>
                  <option value="Hernian">Hernian</option>
                  <option value="Boss">Boss</option>
                  <option value="Others">Others</option>
                </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Date From</label>
                <input type="date" id="input_datefrom" class="form-control" v-model="search.datefrom">
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Date To</label>
                <input type="date" id="input_dateto" class="form-control" v-model="search.dateto">
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Sell To</label>
                <select id="select_sellto" class="form-control" v-model="search.sellto">
                  <option value="%">All</option>
                  <option value="Ican Bukit Kuang">Ican Bukit Kuang</option>
                  <option value="SAWIT JUNUN ENTERPRISE">SAWIT JUNUN ENTERPRISE</option>
                  <option value="GKS SAWIT SDN BHD">GKS SAWIT SDN BHD</option>
                  <option value="PL OIL PALM & RUBBER SDN BHD">PL OIL PALM & RUBBER SDN BHD</option>
                  <option value="BAN HUAT BT3">BAN HUAT BT3</option>
                  <option value="Sawit Bukit Selambau Trading">Sawit Bukit Selambau Trading</option>
                  <option value="Sawit Padang Sekawan Sdn Bhd">Sawit Padang Sekawan Sdn Bhd</option>
                  <option value="Setia Kawan Kilang Kelapa Sawit Sdn Bhd">Setia Kawan Kilang Kelapa Sawit Sdn Bhd</option>
                  <option value="Other">Other</option>
                </select>
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " id="btn_search" style="margin-right: 10px;" @click="getSalesBuahList">Search</button>
                <button class="btn btn-primary " id="btn_export" @click="exportSalesBuahList">Export</button>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Total Weight: {{ ttlSalesBuah.ttl_weight }} Tonne</label>
            </div>
            <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Est Sales: {{ formattedTtlPrice }}</label>
            </div>
          </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Block
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Payment
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Details
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Date
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Remark
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(salesBuah,index) in paginatedSalesBuah" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*10 + index +1 }}. {{ salesBuah.blockid }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ salesBuah.blockname}}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ salesBuah.price }} RM/T</h6>
                  <p class="text-xs text-secondary mb-0">{{ salesBuah.sellto }}</p>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ salesBuah.weight }} Tonne</h6>
                  <p class="text-xs text-secondary mb-0">Perkerja: {{ salesBuah.perkerja }}</p>
                  <p class="text-xs text-secondary mb-0">Driver: {{ salesBuah.driver }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">Sell: {{ salesBuah.sell_at }}</p>
                  <p class="text-xs font-weight-bold mb-0">Price: MYR {{ salesBuah.estprice }}</p>
                  <p class="text-xs font-weight-bold mb-0">Payment: {{ salesBuah.payment }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">Ticket: {{ salesBuah.ticketno }}</p>
                  <p class="text-xs font-weight-bold mb-0">Remark: {{ salesBuah.remark }}</p>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/editSawitBuah/'+ salesBuah.sawitbuahsalesid}"
                    href="javascript:;"
                    class="btn btn-info  font-weight-bold text-xs"
                    style="color: white;"
                    data-toggle="tooltip"
                    data-original-title="Edit Sawit Buah"
                    >Edit
                  </RouterLink>
                  <button class="btn btn-danger font-weight-bold text-xs" @click="removeSawitbuahSales(salesBuah.sawitbuahsalesid)">Remove</button>
                </td>
              </tr>
              
            </tbody>
          </table>
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'salesBuahSelect',
  data(){
    return {
      blockList:[],
      totalRows: 0,
      currentPage: 0,
      perPage: 10,
      searchQuery:'',
      formatLang: 'en-EN',
      formatStyle: 'currency',
      formatCurrency: 'MYR',
      salesBuah: [],
      ttlSalesBuah: {
        ttl_quantity: '0',
        ttl_weight: '0',
        ttl_price: '0'
      },
      search:{
          dateto: new Date().toISOString().slice(0,10),
          datefrom: new Date(this.currentDate()).toISOString().slice(0,10),
          blockid: '',
          perkerja:'%',
          driver:'%',
          sellto:'%',
        },
      removeSawitBuatSales:{
        id:''
      }  
    }
  },
  computed: {
    formatter() {
      return new Intl.NumberFormat(this.formatLang, {
        style: this.formatStyle,
        currency: this.formatCurrency
      })
    },
    formattedTtlPrice() {
      
      return this.formatter.format(this.ttlSalesBuah.ttl_price)
    },
    totalPages() {
      return Math.ceil(this.salesBuah.length / this.perPage);
    },
    paginatedSalesBuah() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.salesBuah.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getSalesBuahList();
    this.listAllBlock();
  },
  methods: {
    listAllBlock(){
        this.blockList = [];
        axios.get('block/getBlockidList')
            .then(res => {
            // console.log(res.data.blockidList,"Success");
            res.data.blockidList.forEach(element => {
                var blockObj = {
                    "text": element.blockid, "value":element.blockname
                }
                this.blockList.push(blockObj);
                
              });
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
            
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currentDate() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    getSalesBuahList(){
      var blockid = '%';
        if(this.search.blockid != ''){
            blockid = this.search.blockid;
        }
        axios.get('block/listSalesBuah/' + this.search.datefrom + "/" + this.search.dateto + "/" +  blockid + "/" + this.search.perkerja + "/" + this.search.driver + "/" + this.search.sellto)
            .then(res => {
              // console.log(res.data.salesBuah);
              this.salesBuah = res.data.salesBuah;
              this.totalRows = res.data.salesBuah.length;
              this.currentPage = 1;
              this.ttlSalesBuah.ttl_quantity= res.data.ttlSalesBuah[0].ttl_quantity;
              this.ttlSalesBuah.ttl_weight= res.data.ttlSalesBuah[0].ttl_weight;
              let username = localStorage.getItem('username');
              if(username != 'weize'){
                this.ttlSalesBuah.ttl_price = 0;
              }else{
                this.ttlSalesBuah.ttl_price= res.data.ttlSalesBuah[0].ttl_price;
              }
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    removeSawitbuahSales(id){
      if(confirm("Do you really want to remove this saiwt buah sales records? ID - " + id)){
        this.removeSawitBuatSales.id = id;
        axios.post('block/removeSawitBuatSales',this.removeSawitBuatSales)
            .then(res => {
                alert(res.data.message);
                this.removeSawitBuatSales = '';
                this.getSalesBuahList();
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: ID is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
      }
    },
    exportSalesBuahList(){
      
      let exportSawitBuahList = [];
      let totalWeight = 0.00;
      let totalPeice = 0;
      this.salesBuah.forEach(e => {
        totalWeight = Number(totalWeight) + Number(e.weight);
        totalPeice = Number(totalPeice) + Number(e.price);
            exportSawitBuahList.push({
                "Block ID":e.blockid,
                "Block Name": e.blockname,
                "Weight(Tonne)":e.weight,
                "Perkerja":e.perkerja,
                "Price":e.price,
                "Sell Date": e.sell_at,
                "Insert Date": e.created_at,
                "Ticketno": e.ticketno,
                "Remark": e.remark,
            });
        });
        exportSawitBuahList.push({
                "Block ID":"Total",
                "Block Name": '',
                "Weight(Tonne)":Number(totalWeight).toFixed(2),
                "Perkerja":'',
                "Price":Number(totalPeice/exportSawitBuahList.length).toFixed(2),
                "Sell Date": '',
                "Insert Date": '',
                "Ticketno": '',
                "Remark": ''
            });
        if(exportSawitBuahList.length<0 || (exportSawitBuahList == '') ){
            alert("Please search the block pls. ");
        }else{
            let fileName = 'SawitBuahList_' + this.search.blockid + '_'+ this.search.datefrom + '_' + this.search.dateto ;
            const csvContent = this.convertToCSV(exportSawitBuahList);
            const blob = new Blob([csvContent],{type:'text/csv;charset=utf-8'});
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName+'.csv');
            link.click();
        }
    },
    convertToCSV(data){
        const headers = Object.keys(data[0]);
        const rows = data.map(obj => headers.map(header => obj[header]));
        const headerRow = headers.join(',');
        const csvRows = [headerRow, ...rows.map(row => row.join(','))];

        return csvRows.join('\n');

    }
  },
}
</script>
  